import React from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import emailjs from "emailjs-com";
import buttonarrowactive from "../../assets/Buttonarrow.svg";
// import buttonarrowinactive from "../../assets/Buttoninactive.svg";

// Validation schema
const ContactSchema = Yup.object().shape({
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  phone: Yup.string().required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
  message: Yup.string(),
});

const FooterContact = () => {
  const sendEmail = (values, { resetForm, setSubmitting }) => {
    emailjs
      .send(
        "service_16dxod9", // EmailJS service ID
        "template_0dddk3f", // EmailJS template ID
        {
          firstName: values.firstName,
          lastName: values.lastName,
          phone: values.phone,
          email: values.email,
          message: values.message,
        },
        "cqGhcQoxEAW7F74gh" // EmailJS public key
      )
      .then(() => {
        alert("Message sent successfully!");
        resetForm();
        setSubmitting(false);
      })
      .catch((err) => {
        alert("Failed to send message.");
        console.error(err);
        setSubmitting(false);
      });
  };

  return (
    <section className="bg-white my-6">
      <div className="grid grid-cols-1 md:grid-cols-12 md:gap-5 gap-3  ">
        {/* max-w-7xl mx-auto  */}
        {/* Left Column */}
        <div className="md:col-span-6  flex flex-col justify-between md:pr-[68px]">
          {/* Top Heading */}
          <div>
            <h2 className="font-garamond-subheading text-[#2C3075] mb-6">
              Get in touch
            </h2>
          </div>

          {/* Bottom Content */}
          <div className="text-[#2C3075] font-generalsans-description">
            {/* Divider */}
            <hr className="border-[#2C3075] mb-3 md:mb-6" />

            {/* Text */}
            <p className="mb-3 md:mb-6">
              Reach out to us to make an enquiry or book an appointment. Simply
              fill in the enquiry form or give us a call.
            </p>

            {/* Email */}
            <p className="">
              <strong>Email: </strong>
              <a
                href="mailto:care.arambhrehab@gmail.com"
                className="text-[#2C3075] hover:underline"
              >
                care.arambhrehab@gmail.com
              </a>
            </p>

            {/* Phone */}
            <p className="mb-3 md:mb-6">
              <strong>Phone: </strong>
              <a
                href="tel:+919004401820"
                className="text-[#2C3075] hover:underline"
              >
                +91 9004401820
              </a>{ " "}
              <span>|</span>
              <a
                href="tel:+919004496820"
                className="text-[#2C3075] hover:underline"
              >
                +91 9004496820
              </a>{ " "}
              <span>|</span>
              <a
                href="tel:+919004439820"
                className="text-[#2C3075] hover:underline"
              >
                +91 9004439820
              </a>
              
            </p>

            {/* Divider */}
            <hr className="border-[#2C3075] mb-3 md:mb-6" />

            {/* Clinics */}
            <div>
              <h3 className="mb-3 md:mb-6 font-semibold">Our clinics:</h3>

              <div className="flex md:flex-row  flex-col justify-between  mb-3 md:mb-6">
                <p className="flex items-center mb-3 md:mb-6 cursor-pointer">
                  Happy solutions{" "}
                  <a
                    href="https://maps.app.goo.gl/BGFAcwqMccqBEw1g8"
                    target="blank"
                  >
                    <span className="flex items-center justify-center rounded-full bg-[#2C3075] md:w-7 w-[18px]  md:h-7 h-[16px] ml-3">
                      <img
                        src={buttonarrowactive}
                        alt="arrow"
                        className="w-5 h-5"
                      />
                    </span>
                  </a>
                </p>
                <p className="flex items-center mb-3 md:mb-6 cursor-pointer">
                  Arambh Rehabilitation Center
                  <a
                    href="https://maps.app.goo.gl/8c5ZEDHACWRKnwGw5"
                    target="blank"
                  >
                    <span className="flex items-center justify-center rounded-full  md:w-7 w-[18px]  md:h-7 h-[16px] ml-3">
                      <img
                        src={buttonarrowactive}
                        alt="arrow"
                        className="w-5 h-5"
                      />
                    </span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column (Form) */}
        <div className="md:col-span-6 font-generalsans-description bg-[#FFEDA9] p-6 px-[18px] md:p-10 rounded-lg">
          <div className="mb-[100px] ">
            <h3 className="text-[#2C3075] font-generalsans-subheading mb-8">
              Online Enquiry
            </h3>
            <p className="text-[#2C3075] mb-6 md:mb-8">
              Please feel free to get in touch at any time. We look forward to
              supporting you.
            </p>
          </div>

          <Formik
            initialValues={{
              firstName: "",
              lastName: "",
              phone: "",
              email: "",
              message: "",
            }}
            validationSchema={ContactSchema}
            onSubmit={sendEmail}
          >
            {({ errors, touched, isSubmitting }) => (
              <Form className="grid grid-cols-1 md:grid-cols-2  md:gap-6 gap-3">
                {/* First Name */}
                <div className=" mb:mb-[40px] mb-[14px] ">
                  <Field
                    name="firstName"
                    placeholder="First Name *"
                    className="border-b  bg-transparent border-[#2C3075] text-[#2C3075] placeholder-[#2C3075] focus:border-[#2C3075] outline-none pb-2 w-full"
                  />
                  {errors.firstName && touched.firstName && (
                    <div className="text-red-500 text-sm">
                      {errors.firstName}
                    </div>
                  )}
                </div>

                {/* Last Name */}
                <div className="mb:mb-[40px] mb-[14px]">
                  <Field
                    name="lastName"
                    placeholder="Last Name *"
                    className="border-b bg-transparent border-[#2C3075] text-[#2C3075] placeholder-[#2C3075] focus:border-[#2C3075] outline-none pb-2 w-full"
                  />
                  {errors.lastName && touched.lastName && (
                    <div className="text-red-500 text-sm">
                      {errors.lastName}
                    </div>
                  )}
                </div>

                {/* Email */}
                <div className="mb:mb-[40px] mb-[14px]">
                  <Field
                    name="email"
                    placeholder="Email *"
                    className="border-b bg-transparent border-[#2C3075] text-[#2C3075] placeholder-[#2C3075] focus:border-[#2C3075] outline-none pb-2 w-full"
                  />
                  {errors.email && touched.email && (
                    <div className="text-red-500 text-sm">{errors.email}</div>
                  )}
                </div>

                {/* Phone */}
                <div className="mb:mb-[40px] mb-[14px]  ">
                  <Field
                    name="phone"
                    placeholder="Phone Number *"
                    className="border-b bg-transparent border-[#2C3075] text-[#2C3075] placeholder-[#2C3075] focus:border-[#2C3075] outline-none pb-2 w-full"
                  />
                  {errors.phone && touched.phone && (
                    <div className="text-red-500 text-sm">{errors.phone}</div>
                  )}
                </div>

                {/* Message */}
                <div className="md:col-span-2 mb:mb-[40px] mb-[14px] ">
                  <Field
                    as="textarea"
                    name="message"
                    rows="4"
                    placeholder="Type your concern / message here..."
                    className="border-b bg-transparent border-[#2C3075] text-[#2C3075] placeholder-[#2C3075] focus:border-[#2C3075] outline-none pb-2 w-full resize-none"
                  />
                </div>

                {/* Submit button */}
                <div className="md:col-span-2 flex  justify-start">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className="relative bg-transparent border-[#2C3075] border-[1px]  text-[#2C3075] rounded-full pl-[16px] pr-[8px] py-3 cursor-pointer hover:bg-[#d7d9ea] transition flex items-center"
                  >
                    <span className="font-medium">
                      {isSubmitting ? "Sending..." : "Submit Enquiry"}
                    </span>
                    <span className="flex items-center justify-center rounded-full bg-[#2C3075] w-7 h-7 ml-3">
                      <img
                        src={buttonarrowactive}
                        alt="arrow"
                        className="w-5 h-5"
                      />
                    </span>
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </section>
  );
};

export default FooterContact;
